const NewDriver = ({ courseDetail, attachment }) => {
 
  return (
    <>
      <div className="new-driver-content">
        <div className="container">
          <div className="row">
            {courseDetail && (
              <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 text-white">
                <div
                  dangerouslySetInnerHTML={{ __html: courseDetail.content }}
                ></div>
              </div>
            )}
            {attachment && attachment.length &&
              attachment.map((attachmentsData, aIndex) => (
                <div
                  key={aIndex}
                  className="col-6 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2 mb-md-5 mb-3"
                >
                  <a className="pointer-link">
                    <img onClick={() => window.open(attachmentsData.file_url) } src={attachmentsData.thumb_url} alt="" />
                  </a>
                </div>
              ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default NewDriver;
